import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { isNil } from 'lodash';
import { VSpecService } from '../../services/api/vspec.service';
import { SharedFunctionService } from '../../services/common/shared-function.service';
//
// Store
//
import { Store } from '@ngrx/store';
import * as fromRootStore from '../../store';
import { IAppState, MenuStore } from '../../store/index';


@Component({
  selector: 'dd-vehicle-card',
  templateUrl: './vehicle-card.component.html',
  styleUrls: ['./vehicle-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VehicleCardComponent implements OnInit {

  @Input() responseData: any;

  @Input('vehicle')
  get vehicle(): any {
    return this.vehicleDetails;
  }
  set vehicle(value: any) {
    // Load the detail from the token
    this.vehicleDetails = value;
    this.hashValue = value.vspecHashVal;
    if (!isNil(this.vehicleDetails.media) && this.vehicleDetails.media.length > 0) {
      this.imgExterior = this.vehicleDetails.media[0].href;
    }
    this.mpgDetails = this.sharedFunctionService.populateMpgValues(this.vehicleDetails);

    // Load the detail from VSpec service
    if (!isNil(this.vehicleDetails)) {
      this.showLoading = true;
      this.vSpecService.getVehicleDetails(this.vehicleDetails.vin, this.responseData.dealerCd, this.hashValue)
        .subscribe(vehicle => {
          this.showLoading = false;
          this.vehicleDetails = vehicle;
          const imgExt = this.vehicleDetails.media.filter(x => x.type === 'exterior');
          if (!isNil(imgExt) && imgExt.length > 0) {
            this.imgExterior = imgExt[0].href;
          }
          this.mpgDetails = this.sharedFunctionService.populateMpgValues(this.vehicleDetails);
        }, (errorResponse) => {
          if (errorResponse.status === 404) {
            this.noLongerAvailable = true;
          }
          this.showLoading = false;
        });
    }
  }

  @Input()
  cardNumber: string;

  public showLoading: Boolean = false;
  public noLongerAvailable: Boolean = false;
  public vehicleDetails: any = null;
  public hashValue: string;
  public imgExterior: String;
  public mpgDetails: any = null;

  ngOnInit() {
  }

  navigateToVehicleDetails() {

    //
    // Go to page
    //
    this.router.navigate([`/v-spec/${this.vehicle.dealerCd}/${this.vehicle.vin}`], {queryParams: {k: this.hashValue}});
  }

  constructor(
    private _store: Store<fromRootStore.IAppState>,
    public vSpecService: VSpecService,
    public sharedFunctionService: SharedFunctionService,
    public router: Router
  ) {

  }
}
